import React from 'react';
import styled from 'styled-components';

interface LoadingTextProps {
  text?: string;
}

const LoadingText: React.FC<LoadingTextProps> = ({ text = '处理中...' }) => {
  return (
    <StyledWrapper>
      <div className="loader" />
      <div className="loading-text">{text}</div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);

  .loader {
    width: 24px;
    height: 24px;
    position: relative;
    flex-shrink: 0;
  }

  .loader:before {
    content: '';
    width: 24px;
    height: 3px;
    background: #f0808050;
    position: absolute;
    top: 30px;
    left: 0;
    border-radius: 50%;
    animation: shadow324 0.5s linear infinite;
  }

  .loader:after {
    content: '';
    width: 100%;
    height: 100%;
    background: #f08080;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 4px;
    animation: jump7456 0.5s linear infinite;
  }

  .loading-text {
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    font-weight: 500;
  }

  @keyframes jump7456 {
    15% {
      border-bottom-right-radius: 3px;
    }

    25% {
      transform: translateY(4px) rotate(22.5deg);
    }

    50% {
      transform: translateY(9px) scale(1, .9) rotate(45deg);
      border-bottom-right-radius: 20px;
    }

    75% {
      transform: translateY(4px) rotate(67.5deg);
    }

    100% {
      transform: translateY(0) rotate(90deg);
    }
  }

  @keyframes shadow324 {
    0%, 100% {
      transform: scale(1, 1);
    }

    50% {
      transform: scale(1.2, 1);
    }
  }
`;

export default LoadingText; 